import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PlatformItem as StyledPlatformItem,
  PlatformLabel,
  AddButton,
  PlatformProgressContainer,
  PlatformProgressWrapper,
  PlatformProgressBar,
  CancelButton,
  CancelIcon,
} from './styles';

interface PlatformItemProps {
  platform: {
    key: string;
    label: string;
    required: boolean;
  };
  isUploading: boolean;
  progress: number;
  hasFile: boolean;
  onAddClick: () => void;
  onCancelClick: () => void;
}

export const PlatformItem: FC<PlatformItemProps> = ({
  platform,
  isUploading,
  progress,
  hasFile,
  onAddClick,
  onCancelClick,
}) => {
  const { t } = useTranslation();

  return (
    <StyledPlatformItem>
      <PlatformLabel $isRequired={platform.required}>
        {platform.label}
      </PlatformLabel>
      
      {isUploading ? (
        <PlatformProgressContainer>
          <PlatformProgressWrapper>
            <PlatformProgressBar progress={progress} />
          </PlatformProgressWrapper>
          <CancelButton onClick={onCancelClick}>
            <CancelIcon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </CancelIcon>
          </CancelButton>
        </PlatformProgressContainer>
      ) : (
        <AddButton onClick={onAddClick}>
          {hasFile ? t('room_launch.replace_button') : t('room_launch.add_button')}
        </AddButton>
      )}
    </StyledPlatformItem>
  );
};
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  PlatformItem as StyledPlatformItem,
  PlatformLabel,
  AddButton,
  PlatformProgressContainer,
  PlatformProgressWrapper,
  PlatformProgressBar,
  CancelButton,
  CancelIcon,
} from './styles';

interface PlatformItemProps {
  platform: {
    key: string;
    label: string;
    required: boolean;
  };
  isUploading: boolean;
  progress: number;
  hasFile: boolean;
  onAddClick: () => void;
  onCancelClick: () => void;
}

export const PlatformItem: FC<PlatformItemProps> = ({
  platform,
  isUploading,
  progress,
  hasFile,
  onAddClick,
  onCancelClick,
}) => {
  const { t } = useTranslation();

  return (
    <StyledPlatformItem>
      <PlatformLabel $isRequired={platform.required}>
        {platform.label}
      </PlatformLabel>
      
      {isUploading ? (
        <PlatformProgressContainer>
          <PlatformProgressWrapper>
            <PlatformProgressBar progress={progress} />
          </PlatformProgressWrapper>
          <CancelButton onClick={onCancelClick}>
            <CancelIcon viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </CancelIcon>
          </CancelButton>
        </PlatformProgressContainer>
      ) : (
        <AddButton onClick={onAddClick}>
          {hasFile ? t('room_launch.replace_button') : t('room_launch.add_button')}
        </AddButton>
      )}
    </StyledPlatformItem>
  );
};
